import moment from 'moment';
import viLocale from 'moment/locale/vi';
import { DATE_ACTIONS } from 'constants/common';
import { isEmpty } from 'lodash';

export const DATE_TIME_FORMAT = {
  DATE_TIME_FORMAT_NO_SECOND_12H: 'MMM DD, YYYY - h:mm:00 A',
  MMM_YYY_WITH_COMMA: 'MMM, YYYY',
  MONTH_IN_TEXT_FORMAT: 'MMM DD, YYYY',
  DD_MMM_YYYY: 'DD MMM YYYY',
  DD_MMM_YYYY_2: 'DD/MM/YYYY',
  MM_DD_YYYY: 'MM/DD/YYYY',
  DATE_ISO: 'YYYY-MM-DD'
};

const LOCALE = {
  vi: viLocale,
};

export const setMomentLocale = (language = 'en') => {
  if (language === 'en') {
    moment.locale(language);
    return;
  }
  moment.updateLocale(language, LOCALE[language]);
};

setMomentLocale(localStorage.getItem('language') || 'en');

export const getTimeLocal = (time = new Date()) => {
  return moment.utc(time).local();
};

export const getTimeFormat = (time, format = 'DD MMM YYYY - hh:mm:ss') => {
  return time ? moment(time).format(format) : '';
};

export const getTimeFormatDateTime = (time = new Date()) => {
  return moment.utc(time).local().format('LLLL');
};

export const getTimeFromNow = (t = moment()) => {
  const now = moment();
  const time = moment.utc(t).local();
  const timeFromNow = now - time;
  if (timeFromNow <= 3600000) {
    // 3600000  = 1 hour
    return time.fromNow().replace('minute', 'min');
  }
  if (timeFromNow <= 86400000)
    // 86400000 = 1 day
    return time.format('hh:mma').toLocaleUpperCase();
  return time.format('DD/MM/YYYY');
};

export const parseISO = (time = '', hours = '00:00:00') => {
  return moment(time, 'MM/DD/YYYY HH:mm:ss A').format(
    `YYYY-MM-DDT${hours}+00:00`
  );
};

export const parseUTC = (
  date,
  action = '',
  segment = 'days',
  shouldParseToUtc = true
) => {
  if (isEmpty(date)) return null;

  let parsedDate = moment(date);

  if (action === DATE_ACTIONS.START) {
  }

  if (action === DATE_ACTIONS.END) {
    parsedDate.endOf(segment);
  }

  return shouldParseToUtc
    ? parsedDate.utc().toISOString()
    : parsedDate.toISOString();
};

export const getDateOnly = (date) => {
  if (isEmpty(date)) return undefined;
  return moment(date).format(DATE_TIME_FORMAT.DATE_ISO);
} 

export const pad = (value) => {
  return value < 10 ? '0' + value : value;
};

export const currentTimeZone = () => {
  const date = new Date();
  const sign = date.getTimezoneOffset() > 0 ? '-' : '+';
  const offset = Math.abs(date.getTimezoneOffset());
  const hours = pad(Math.floor(offset / 60));
  return parseInt(`${sign}${hours}`);
};

export const getDisabledTime = (form, date, isStart = true) => {
  if (date) {
    const currentDate = moment();
    if (date.isSame(currentDate, 'day')) {
      return {
        disabledHours: isStart
          ? () => range(0, currentDate.hour())
          : () => range(currentDate.hour() + 1, 24),
        disabledMinutes: isStart
          ? () =>
              date.hour() > currentDate.hour()
                ? []
                : range(0, currentDate.minute())
          : () =>
              date.hour() < currentDate.hour()
                ? []
                : range(currentDate.minute() + 1, 60),
      };
    } else {
      if (isStart) {
        const endDate = form.getFieldValue('endDate');
        if (endDate && date.isSame(endDate, 'day')) {
          return {
            disabledHours: () => range(endDate.hour() + 1, 24),
            disabledMinutes: () =>
              date.hour() < endDate.hour()
                ? []
                : range(endDate.minute() + 1, 60),
          };
        }
      }
    }
  }
  return {};
};
